// ** Third Party Components
import { renderRoutes } from "react-router-config";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardTitle } from "components/layout/Card/CardTitle";
import { CardsBlockWrapper } from "components/layout/Card/CardsBlockWrapper";
import Heading from "components/typography/Heading";
import EmptyBlock from "components/layout/Block/BlockEmpty";
import ScrollToTop from "components/global/ScrollToTop";

// ** Custom Hooks
import useOpenGraphMetaTags from "hooks/useOpenGraphMetaTags";

// #####################################################

const News = ({ route: { key, routes } }) => {
	const { t } = useTranslation(["pages"]);
	const title = t(key);

	// ** Open Graph Meta Tags
	const ogMetaTags = useOpenGraphMetaTags({
		customTitle: `${title} - ${t("common:titleTemplate")}`,
	});

	// #####################################################

	return (
		<>
			{/* Sekcja HEAD */}
			<Helmet title={title}>{ogMetaTags}</Helmet>

			<ScrollToTop />

			<CardsBlockWrapper>
				{/* Nagłówek */}
				<CardWrapper>
					<CardTitle $withPaddingBottom>
						<Heading type="h2" data-testid="news-heading">
							{t("pages:news")}
						</Heading>
					</CardTitle>
				</CardWrapper>

				{/* Główna zawartość strony */}
				{renderRoutes(routes)}

				<EmptyBlock />
			</CardsBlockWrapper>
		</>
	);
};

// #####################################################

export default News;
